import { render, staticRenderFns } from "./LineItemDetailsDialog.vue?vue&type=template&id=36ca7a42&scoped=true"
import script from "./LineItemDetailsDialog.vue?vue&type=script&lang=js"
export * from "./LineItemDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./LineItemDetailsDialog.vue?vue&type=style&index=0&id=36ca7a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca7a42",
  null
  
)

export default component.exports